// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../admin/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Bulma Utilities */\n@media screen and (min-width: 769px) {\na[href*=\"tel:\"][data-v-02e60981] {\n    cursor: default;\n    pointer-events: none;\n    color: hsl(0deg, 0%, 29%);\n}\n}\n.has-addons[data-v-02e60981] {\n  margin-bottom: 1.5em;\n}\n.form-checkbox-set[data-v-02e60981] {\n  margin-bottom: 1em;\n}\nli[data-v-02e60981] {\n  margin-bottom: 0.5em;\n}", ""]);
// Exports
module.exports = exports;
